import { fetchJson } from '@atlassian/jira-fetch/src/index.tsx';
// eslint-disable-next-line jira/import-whitelist
import { expVal } from '@atlassian/jira-feature-experiments';
import type { IncidentSuggestion } from '../common/types.tsx';
import type { IncidentSuggestionRequestParams } from './types.tsx';
import { transformResponse, transformResponseV2 } from './utils.tsx';

export const getIncidentSuggestionUrl = ({
	cloudId,
	issueId,
	projectId,
	locale,
}: IncidentSuggestionRequestParams): string =>
	`/gateway/api/jsm/aiops/cloudId/${cloudId}/api/v1/incident-suggestion/${issueId}?projectId=${projectId}&locale=${locale}
`;

export const getIncidentSuggestionEndpoint = (
	reqParams: IncidentSuggestionRequestParams,
): Promise<IncidentSuggestion> => {
	const url = getIncidentSuggestionUrl(reqParams);
	return fetchJson(url, {
		method: 'GET',
	}).then(
		expVal('aiops_context_panel_ui_update_experiment', 'isEnabled', false)
			? transformResponseV2
			: transformResponse,
	);
};
